/* eslint-disable no-param-reassign,@typescript-eslint/ban-ts-comment */
import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    isLoading: false,
    match: null,
    matchState: null,
    showRoles: false,
    showShooters: true,
};
export const MatchSlice = createSlice({
    name: 'match',
    initialState,
    reducers: {
        setMatch: (state, action) => {
            state.match = action.payload;
        },
        setMatchState: (state, action) => {
            state.matchState = action.payload;
        },
        setMatchLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        toggleShowRoles: (state) => {
            state.showRoles = !state.showRoles;
        },
        toggleShowShooters: (state) => {
            state.showShooters = !state.showShooters;
        },
        resetShowShooters: (state) => {
            state.showShooters = true;
        },
    },
});
export default MatchSlice.reducer;
export const { setMatch, setMatchLoading, setMatchState, toggleShowRoles, toggleShowShooters, resetShowShooters } = MatchSlice.actions;
export const selectMatch = (state) => state.match.match;
export const selectMatchLoading = (state) => state.match.isLoading;
export const selectMatchState = (state) => state.match.matchState;
export const selectShowRoles = (state) => state.match.showRoles;
export const selectShowShooters = (state) => state.match.showShooters;
